import jinjaToJS from "jinja-to-js";export default function templateModulesLoadingSpinner(ctx) {
    var __result = "";
    var __tmp;
    var __runtime = jinjaToJS.runtime;
    var __filters = jinjaToJS.filters;
    var __globals = jinjaToJS.globals;
    var context = jinjaToJS.createContext(ctx);
    __result += "<div class=\"loading-square ";if(__runtime.boolean(context.color)){__result += "loading-square--";__result += "" + __runtime.escape((__tmp = (context.color)) == null ? "" : __tmp);}__result += " ";__result += "" + __runtime.escape((__tmp = ((context.inline ? "loading-square--inline" : null))) == null ? "" : __tmp);__result += "\">\n    <div class=\"loading-square__lr\"></div>\n    <div class=\"loading-square__tb\"></div>\n</div>";
    return __result;
}